<template>
  <BContainer
    class="px-0"
    fluid
  >
    <BSkeletonWrapper
      :loading="loading"
    >
      <template #loading>
        <div
          class="iq-card officer-profile mb-0 shadow-none"
        >
          <div class="iq-card-body profile-page p-0">
            <div class="profile-header p-4">
              <div class="profile-info">
                <div class="row">
                  <div class="col-12">
                    <div class="user-details pl-md-3">
                      <div class="d-flex flex-column flex-md-row justify-content-center justify-content-md-start align-items-center">
                        <div class="profile-img mb-3 mb-md-0">
                          <div class="profile-overlay-container">
                            <BSkeleton
                              type="avatar"
                              size="130px"
                              variant="primary"
                            />
                          </div>
                        </div>
                        <div class="d-flex flex-column align-items-center align-items-md-start pl-md-3">
                          <BSkeleton
                            width="260px"
                            height="25px"
                          />
                          <BSkeleton width="50px" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-12 col-md-6" /> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div
        class="iq-card officer-profile mb-0 shadow-none"
      >
        <div class="iq-card-body profile-page p-0">
          <div class="profile-header p-4">
            <div class="profile-info">
              <div class="row">
                <div class="col-12">
                  <div class="user-details pl-md-3">
                    <div class="d-flex flex-column flex-md-row justify-content-center justify-content-md-start align-items-center">
                      <div class="profile-img mb-3 mb-md-0">
                        <div class="profile-overlay-container">
                          <BAvatar
                            v-if="officer.photo_url"
                            :src="cProfilePath"
                            variant="primary"
                            size="130px"
                          />
                          <BAvatar
                            v-else
                            variant="primary"
                            size="130px"
                            :text="String(officer.first_name).charAt(0) + String(officer.last_name).charAt(0)"
                          />
                        </div>
                      </div>
                      <div class="d-flex flex-column align-items-center align-items-md-start pl-md-3">
                        <h5 class="text-capitalize">
                          {{ officer.first_name }} {{ officer.last_name }}
                        </h5>
                        <p class="m-0 small">
                          Clusters: {{ Array.from(officer.clusters).map(cluster => cluster?.cluster_name).join(', ') }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-12 col-md-6" /> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </BSkeletonWrapper>
  </BContainer>
</template>
<script>
import MxMisc from '@/mixins/misc'

export default {
  name: 'ASMOfficerTasksProfilePictures',

  mixins: [
    MxMisc
  ],

  props: {
    loading: {
      type: Boolean,
      default: () => false
    },

    officer: {
      type: Object,
      default: () => ({
        id: '',
        role_id: '',
        username: '',
        first_name: '',
        last_name: '',
        mobile_number: '',
        address: '',
        sso_id: '',
        email: '',
        notification_email: '',
        clusters: [],
        photo_url: '',
        active: 1
      })
    }
  },

  data () {
    return {
      state: {
        busy: false
      }
    }
  },

  computed: {
    cProfilePath () {
      return `${process.env.VUE_APP_API_BASE_URL}/${this.officer.photo_url}`
    }
  }
}
</script>
<style lang="scss">
  .profile-overlay-container {
    position: relative;
    width: 100%;
  }

  .profile-overlay-middle {
    bottom: 0;
    right: 0;
    position: absolute;
  }
</style>
